import React from "react";
import { Mail, Instagram, ArrowUpRight } from "lucide-react";
import Layout from "../components/Layout";
import { useContent } from "../contexts/SiteContentContext";

const ICONS = {
  email: <Mail className="w-5 h-5" />,
  instagram: <Instagram className="w-5 h-5" />,
};

function channelIcon(label) {
  const l = (label || "").toLowerCase();
  if (l.includes("email") || l.includes("mail")) return ICONS.email;
  if (l.includes("insta")) return ICONS.instagram;
  return <Mail className="w-5 h-5" />;
}

export default function Contacto() {
  const c = useContent("contacto_page");
  const channels = c.channels || [];
  const faq = c.faq_items || [];

  return (
    <Layout>
      <section data-testid="contacto-hero" className="pt-20 pb-12 border-b border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="section-tag mb-4">{c.eyebrow || "Linha direta"}</p>
          <h1 className="headline text-5xl md:text-7xl lg:text-8xl mb-6 leading-[0.9]">{c.title || "Contacto"}</h1>
          <p className="text-bone-muted text-base md:text-lg max-w-2xl leading-relaxed">
            {c.subtitle || "Entra em contacto."}
          </p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <p className="section-tag mb-5">Canais oficiais</p>
            <h2 className="headline text-3xl md:text-4xl mb-10 leading-tight">
              Fala connosco.
            </h2>
            <div className="space-y-px bg-white/10">
              {channels.map((ch, i) => (
                <a
                  key={i}
                  href={ch.href}
                  target={ch.href?.startsWith("http") ? "_blank" : undefined}
                  rel={ch.href?.startsWith("http") ? "noopener noreferrer" : undefined}
                  data-testid={`contact-channel-${(ch.label || "").toLowerCase()}`}
                  className="bg-ink-100 hover:bg-ink-200 transition-colors p-6 flex items-center gap-5 group"
                >
                  <div className="text-blood">{channelIcon(ch.label)}</div>
                  <div className="flex-1 min-w-0">
                    <p className="mono text-[10px] text-bone-faded tracking-[0.3em] mb-1">{(ch.label || "").toUpperCase()}</p>
                    <p className="text-white text-base truncate">{ch.value}</p>
                  </div>
                  <ArrowUpRight className="w-4 h-4 text-bone-muted group-hover:text-blood group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
                </a>
              ))}
            </div>

            {c.footer_note && (
              <p className="mono text-[10px] text-bone-faded tracking-[0.2em] leading-relaxed mt-8">
                {c.footer_note}
              </p>
            )}
          </div>

          <div className="lg:col-span-7">
            <div className="flex items-end justify-between mb-8 flex-wrap gap-3">
              <div>
                <p className="section-tag mb-4">{c.faq_title || "FAQ"}</p>
                <h2 className="headline text-3xl md:text-4xl">{c.faq_eyebrow || "Perguntas frequentes"}</h2>
              </div>
              <span className="mono text-[10px] text-bone-faded tracking-[0.3em]">
                {String(faq.length).padStart(2, "0")} ENTRADAS
              </span>
            </div>

            <div className="space-y-px bg-white/10">
              {faq.map((item, i) => (
                <div key={i} className="bg-ink-100 p-6 md:p-7">
                  <div className="flex items-start gap-4">
                    <span className="headline text-2xl text-blood shrink-0">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <div className="flex-1">
                      <h4 className="headline text-lg md:text-xl mb-2">{item.q}</h4>
                      <p className="text-sm text-bone-dim leading-relaxed">{item.a}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
